import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 14 14"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  d: "M8.476 5.525 5.524 8.476a2.086 2.086 0 1 1 2.952-2.952Z"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  d: "M10.395 3.366c-1.02-.77-2.188-1.19-3.395-1.19-2.06 0-3.978 1.213-5.314 3.313-.525.823-.525 2.205 0 3.028.46.723.997 1.347 1.58 1.849M4.912 11.393c.665.28 1.37.431 2.088.431 2.06 0 3.978-1.213 5.314-3.313.525-.823.525-2.205 0-3.028a9.467 9.467 0 0 0-.618-.857"
}, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("path", {
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  d: "M9.047 7.408a2.08 2.08 0 0 1-1.645 1.645M5.524 8.476l-4.357 4.357M12.834 1.167 8.476 5.524"
}, null, -1)
const _hoisted_5 = [
  _hoisted_2,
  _hoisted_3,
  _hoisted_4
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_5]))
}
export default { render: render }